(function () {
  'use strict';

  window.SF = window.SF || {};
  const SF = window.SF;

  SF.WORKER = 'https://wispy-rain-c7af.chris-646.workers.dev';

  // -- Keyword warnings -------------------------------------------------------
  SF.TICKET_WARNINGS = [
    {
      terms: ['golden teachers', 'ksss', 'penis envy','pan cyans'],
      message: `<h5>Please remove references to magic mushrooms before sending.</h5>`,
      preventSend: true
    }, {
      terms: ['spore', 'syringe', 'mss'],
      message: `<h5>We cannot give advice on growing magic mushrooms!</h5><p>💉You can mention spore syringes - we don't need to know the species.</p><p><strong>Ensure you are staying within the law.</strong></p>`,
      preventSend: 'checkbox',
      checkboxLabel: `It's not about cultivation - I understand I could be banned if I ask`,
    },
    {
      terms: ['mycoworld', 'myco world', 'orangutan', 'sporebuddies', 'martian mushrooms', 'otc'],
      message: `<h5>Please remove references to spore vendors if you are asking about cultivation.</h5>`,
      preventSend: 'checkbox',
      checkboxLabel: `It's not about cultivation - I understand I could be banned if I ask`,
    },
  ];

  SF.checkTicketWarnings = function (textarea, warningEl, submitBtn) {
    const text = (textarea.value || '').toLowerCase();

    // Collect all matching rules
    var matched = [];
    for (var i = 0; i < SF.TICKET_WARNINGS.length; i++) {
      var rule = SF.TICKET_WARNINGS[i];
      if (rule.terms.some(function (t) { return text.includes(t.toLowerCase()); })) {
        matched.push(rule);
      }
    }

    // Preserve checked state of any existing checkboxes by rule message (key)
    var prevChecked = {};
    warningEl.querySelectorAll('.sf-warning-block').forEach(function (block) {
      var cb = block.querySelector('.sf-warning-cb');
      var key = block.dataset.ruleKey;
      if (cb && key) prevChecked[key] = cb.checked;
    });

    // Rebuild warning contents entirely
    warningEl.innerHTML = '';

    if (matched.length === 0) {
      warningEl.style.display = 'none';
      if (submitBtn && submitBtn._sfWarningBlocked) {
        submitBtn.disabled = false;
        submitBtn._sfWarningBlocked = false;
      }
      return;
    }

    warningEl.style.display = '';

    // Determine if submit should be blocked after rendering
    // Re-evaluated after each checkbox change too
    function updateSubmitState() {
      if (!submitBtn) return;
      var blocked = false;
      matched.forEach(function (rule) {
        if (rule.preventSend === true) {
          blocked = true;
        } else if (rule.preventSend === 'checkbox') {
          var block = warningEl.querySelector('[data-rule-key="' + CSS.escape(rule.message) + '"]');
          var cb = block && block.querySelector('.sf-warning-cb');
          if (!cb || !cb.checked) blocked = true;
        }
      });
      submitBtn.disabled = blocked;
      submitBtn._sfWarningBlocked = blocked;
    }

    matched.forEach(function (rule) {
      var block = document.createElement('div');
      block.className = 'sf-warning-block';
      block.dataset.ruleKey = rule.message;
      if (matched.length > 1) {
        block.style.cssText = 'padding-bottom:10px;margin-bottom:10px;border-bottom:1px solid #f5a0a0;';
      }

      var msgSpan = document.createElement('span');
      msgSpan.className = 'sf-warning-msg';
      msgSpan.innerHTML = rule.message;
      block.appendChild(msgSpan);

      if (rule.preventSend === 'checkbox') {
        var cbWrap = document.createElement('label');
        cbWrap.className = 'sf-warning-checkbox-wrap';
        cbWrap.style.cssText = 'display:flex;align-items:flex-start;gap:8px;margin-top:10px;cursor:pointer;font-size:.92em;';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.className = 'sf-warning-cb';
        cb.style.cssText = 'margin-top:2px;flex-shrink:0;cursor:pointer;';
        cb.checked = !!prevChecked[rule.message];
        var cbLabel = document.createElement('span');
        cbLabel.textContent = rule.checkboxLabel || 'I confirm I understand.';
        cbWrap.appendChild(cb);
        cbWrap.appendChild(cbLabel);
        block.appendChild(cbWrap);
        cb.addEventListener('change', updateSubmitState);
      }

      warningEl.appendChild(block);
    });

    // Remove bottom border from last block
    var blocks = warningEl.querySelectorAll('.sf-warning-block');
    if (blocks.length) blocks[blocks.length - 1].style.borderBottom = 'none';

    updateSubmitState();
  };

  // -- Turnstile (anti-spam) --------------------------------------------------
  SF.TURNSTILE_SITEKEY = document.getElementById('support-flow')?.dataset?.turnstileSitekey || '';
  SF._turnstileWidgetId = null;
  SF._turnstileReady = null;

  SF.loadTurnstile = function () {
    if (SF._turnstileReady) return SF._turnstileReady;
    SF._turnstileReady = new Promise((resolve) => {
      if (!SF.TURNSTILE_SITEKEY) { resolve(false); return; }
      if (window.turnstile) { resolve(true); return; }
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.head.appendChild(script);
    });
    return SF._turnstileReady;
  };

  SF.getTurnstileToken = async function () {
    const ready = await SF.loadTurnstile();
    if (!ready || !window.turnstile) return '';
    if (SF._turnstileWidgetId === null) {
      let container = document.getElementById('sf-turnstile-container');
      if (!container) {
        container = document.createElement('div');
        container.id = 'sf-turnstile-container';
        container.style.display = 'none';
        document.body.appendChild(container);
      }
      SF._turnstileWidgetId = window.turnstile.render(container, {
        sitekey: SF.TURNSTILE_SITEKEY,
        execution: 'execute',
        size: 'invisible',
      });
    }
    const token = await new Promise((resolve) => {
      window.turnstile.execute(SF._turnstileWidgetId, {
        callback: (token) => resolve(token || ''),
        'error-callback': () => resolve(''),
        'timeout-callback': () => resolve(''),
      });
    });
    // Reset immediately so the next call is forced to request a brand new
    // token rather than risk Cloudflare handing back the same one if
    // execute() is called again before a fresh challenge cycle completes.
    try { window.turnstile.reset(SF._turnstileWidgetId); } catch (e) { /* ignore */ }
    return token;
  };

  SF.debugSetLoaded = function () {
    const el = document.getElementById('sf-debug-js');
    if (el) el.textContent = 'YES';
  };
  SF.debugSetErr = function (err) {
    const el = document.getElementById('sf-debug-err');
    if (!el) return;
    el.textContent = String(err && err.stack ? err.stack : err);
  };
  SF.debugLog = function (line) {
    const el = document.getElementById('sf-debug-err');
    if (!el) return;
    el.textContent = (el.textContent ? el.textContent + '\n' : '') + String(line);
  };
  window.addEventListener('error', (e) => {
    SF.debugSetErr(e.error || e.message || e);
    if (SF.main && SF.main.children.length === 0) SF.renderFatal(e.error || e.message || e);
  });
  window.addEventListener('unhandledrejection', (e) => {
    SF.debugSetErr(e.reason || e);
    if (SF.main && SF.main.children.length === 0) SF.renderFatal(e.reason || e);
  });
  SF.debugSetLoaded();

  SF.wrapper = document.getElementById('support-flow');
  SF.main    = document.getElementById('sf-main');
  if (!SF.wrapper || !SF.main) return;

  const cfg          = document.getElementById('sf-login-config');
  const LOGIN_BASE   = cfg?.dataset?.loginBase   || '/customer_authentication/login';
  const SUPPORT_PATH = cfg?.dataset?.supportPath || '/pages/contact-support';

  SF.buildLoginUrl = function (returnHash) {
    const returnTo = SUPPORT_PATH + (returnHash ? '#' + returnHash : '');
    return LOGIN_BASE + '?return_to=' + encodeURIComponent(returnTo);
  };

  SF.customerEmail = (SF.wrapper.dataset.customerEmail || '').trim();
  SF.customerName  = (SF.wrapper.dataset.customerName  || '').trim();
  SF.customerFirst = SF.customerName.split(' ')[0] || SF.customerName;
  SF.customerId    = (SF.wrapper.dataset.customerId    || '').trim();
  SF.customerTs    = (SF.wrapper.dataset.customerTs    || '').trim();
  SF.customerSig   = (SF.wrapper.dataset.customerSig   || '').trim();

  SF.isLoggedIn = function () {
    return (SF.wrapper.dataset.loggedIn || '').toString().toLowerCase() === 'true' ||
      SF.customerEmail.length > 0;
  };

  SF.hasTpl = function (id) { return !!document.getElementById(id); };
  SF.tpl    = function (id) {
    const t = document.getElementById(id);
    if (!t || !t.content) throw new Error('Missing template #' + id);
    return t.content.cloneNode(true);
  };

  SF.authenticatedHeaders = function () {
    return {
      'X-Customer-Email': SF.customerEmail,
      'X-Customer-ID':    SF.customerId,
      'X-Customer-TS':    SF.customerTs,
      'X-Customer-Sig':   SF.customerSig,
    };
  };
  SF._ticketSubmitInFlight = false;
  SF.apiPost = async function (path, body) {
    if (path === '/tickets') {
      if (SF._ticketSubmitInFlight) {
        throw new Error('Already submitting - please wait.');
      }
      SF._ticketSubmitInFlight = true;
    }
    try {
      const finalBody = { ...(body || {}) };
      if (path === '/tickets') {
        finalBody.turnstileToken = await SF.getTurnstileToken();
      }
      const res = await fetch(SF.WORKER + path, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', ...SF.authenticatedHeaders() },
        body:    JSON.stringify(finalBody)
      });
      const d = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(d.error || 'Status ' + res.status);
      return d;
    } finally {
      if (path === '/tickets') SF._ticketSubmitInFlight = false;
    }
  };
  SF.apiGet = async function (path) {
    const res = await fetch(SF.WORKER + path, { headers: SF.authenticatedHeaders() });
    const d   = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(d.error || 'Status ' + res.status);
    return d;
  };

  SF.app = {
    top: '', step: '', stepStack: [],
    ordersLoaded: false, orders: [], ordersHasMore: false, ordersMode: 'recent', ordersLoadingAll: false,
    issueType: null, selectedOrder: null,
    missingItems: [],
    packagingDamaged: null, parcelKeys: [],
    damagedItems: [], damagedItemDetails: {}, damagedIdx: 0,
    deliverySubType: null,
    contamItems: [], contamDetails: {}, contamIdx: 0,
    productProblemItems: [], productProblemIdx: 0, productProblemDetails: {},
    uploaders: {},
    _contactTags: [],
  };

  SF.resetFlow = function () {
    const a = SF.app;
    a.stepStack = []; a.step = 'issue';
    a.issueType = null; a.selectedOrder = null;
    a.missingItems = [];
    a.packagingDamaged = null; a.parcelKeys = [];
    a.damagedItems = []; a.damagedItemDetails = {}; a.damagedIdx = 0;
    a.deliverySubType = null;
    a.contamItems = []; a.contamDetails = {}; a.contamIdx = 0;
    a.productProblemItems = []; a.productProblemIdx = 0; a.productProblemDetails = {};
    a.uploaders = {};
    a._contactTags = [];
  };

  SF.pushStep = function (s) {
    if (SF.app.step) SF.app.stepStack.push(SF.app.step);
    SF.app.step = s;
    SF.renderStep();
  };
  SF.popStep = function () {
    SF.app.step = SF.app.stepStack.pop() || 'issue';
    SF.renderStep();
  };
  SF.loadOrders = async function () {
    if (SF.app.ordersLoaded) return;
    const d = await SF.apiGet('/orders?mode=recent');
    SF.app.orders        = d.orders || [];
    SF.app.ordersHasMore = !!d.hasMore;
    SF.app.ordersMode    = 'recent';
    SF.app.ordersLoaded  = true;
  };
  SF.loadAllOrders = async function () {
    if (SF.app.ordersLoadingAll || SF.app.ordersMode === 'all') return;
    SF.app.ordersLoadingAll = true;
    SF.renderStep();
    try {
      const d = await SF.apiGet('/orders?mode=all');
      SF.app.orders        = d.orders || [];
      SF.app.ordersHasMore = false;
      SF.app.ordersMode    = 'all';
    } catch (err) {
      SF.setStatus(err.message, 'error');
    } finally {
      SF.app.ordersLoadingAll = false;
      SF.renderStep();
    }
  };


  const TOP_HASHES = new Set(['', 'order-problem', 'website', 'cultivation', 'other']);
  SF.getTopHash = function () {
    const h = (window.location.hash || '').replace(/^#/, '').trim().toLowerCase();
    return TOP_HASHES.has(h) ? h : '';
  };
  SF.goTop = function (hash) {
    const h = hash || '';
    if (window.location.hash === (h ? '#' + h : '')) SF.renderTop();
    else window.location.hash = h ? '#' + h : '';
  };

  SF.formatDate = function (iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  };
  SF.fulfilLabel = function (o) {
    if (!o)                                    return '';
    if (o.cancelled_at)                        return 'Cancelled';
    if (!o.dispatched_at)                      return 'Being prepared';
    if (o.fulfillment_status === 'fulfilled')  return 'Dispatched';
    return 'Partially dispatched';
  };
  SF.escapeHtml = function (s) {
    return (s || '').toString()
      .replaceAll('&', '&amp;').replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;').replaceAll('"', '&quot;');
  };

  SF.show = function (content) {
    SF.main.innerHTML = '';
    SF.main.appendChild(content);
    if (SF.app && SF.app.top === 'order-problem') {
      SF.prependProgress(SF.main, SF.app.step);
    }
    const heading = SF.main.querySelector('h1, h2, h3, [role="heading"]');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: false });
    }
  };

  // Step labels for the order-problem flow's progress indicator. Steps that
  // don't apply to a given issue type (e.g. no item picklist for delivery
  // problems) are simply skipped when computing total/current.
  SF.ORDER_FLOW_STEPS = ['select-order', 'details', 'photos', 'extra'];
  SF.stepToProgressIndex = function (step) {
    const detailSteps = ['missing-item', 'damaged-packaging', 'damaged-items', 'contam-select', 'product-select', 'delivery-type', 'delivery-info', 'delivery-roadblock'];
    const photoSteps  = ['damaged-item-detail', 'contam-detail', 'product-detail'];
    const extraSteps  = ['damaged-extra', 'contam-submit', 'contact-form', 'delivery-message'];
    if (step === 'select-order') return 0;
    if (detailSteps.indexOf(step) !== -1) return 1;
    if (photoSteps.indexOf(step) !== -1)  return 2;
    if (extraSteps.indexOf(step) !== -1)  return 3;
    return -1;
  };
  SF.makeProgress = function (step) {
    const idx = SF.stepToProgressIndex(step);
    if (idx === -1) return null;
    const total  = SF.ORDER_FLOW_STEPS.length;
    const wrap   = document.createElement('div');
    wrap.className = 'sf-progress';
    const label = document.createElement('span');
    label.className = 'sf-progress-label';
    label.textContent = 'Step ' + (idx + 1) + ' of ' + total;
    const track = document.createElement('div');
    track.className = 'sf-progress-track';
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('span');
      dot.className = 'sf-progress-dot' + (i < idx ? ' is-complete' : i === idx ? ' is-current' : '');
      track.appendChild(dot);
    }
    wrap.append(label, track);
    return wrap;
  };
  SF.prependProgress = function (root, step) {
    const progress = SF.makeProgress(step);
    if (!progress) return;
    const card = root.querySelector ? (root.classList && root.classList.contains('sf-card') ? root : root.querySelector('.sf-card')) : null;
    const target = card || root;
    const back = target.querySelector ? target.querySelector('.sf-back') : null;
    if (back && back.nextSibling) target.insertBefore(progress, back.nextSibling);
    else if (target.firstChild) target.insertBefore(progress, target.firstChild);
    else target.appendChild(progress);
  };

  SF.SUPPORT_EMAIL = 'support@mycopunks.com';
  SF.renderFatal = function (err) {
    SF.debugSetErr(err);
    const box = document.createElement('div');
    box.className = 'sf-card';
    const heading = document.createElement('h2');
    heading.className = 'sf-title';
    heading.textContent = 'Something went wrong';
    const subtitle = document.createElement('p');
    subtitle.className = 'sf-subtitle';
    subtitle.textContent = "We're having a technical issue with this form right now. Please email us directly and we'll help you out:";
    const emailBox = document.createElement('div');
    emailBox.className = 'sf-info-box';
    const link = document.createElement('a');
    link.href = 'mailto:' + SF.SUPPORT_EMAIL;
    link.className = 'sf-link';
    link.textContent = SF.SUPPORT_EMAIL;
    emailBox.appendChild(link);
    box.append(heading, subtitle, emailBox);
    SF.main.innerHTML = '';
    SF.main.appendChild(box);
  };
  SF.setStatus = function (msg, kind) {
    const el = document.querySelector('#sf-main .sf-status-msg');
    if (el) {
      el.textContent = msg || '';
      el.className   = 'sf-status-msg' + (kind ? ' ' + kind : '');
      el.setAttribute('role',      kind === 'error' ? 'alert'     : 'status');
      el.setAttribute('aria-live', kind === 'error' ? 'assertive' : 'polite');
    }
    if (kind === 'error') {
      const disabledSubmit = SF.main.querySelector('[data-action^="submit-"][disabled]');
      if (disabledSubmit && !disabledSubmit._sfWarningBlocked) {
        disabledSubmit.disabled = false;
        disabledSubmit.classList.remove('is-loading');
        disabledSubmit.textContent = disabledSubmit._sfOriginalText || disabledSubmit.textContent;
      }
    }
  };
  SF.makeCard = function () {
    const el = document.createElement('div');
    el.className = 'sf-card';
    return el;
  };
  SF.makeBackButton = function () {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sf-back';
    btn.setAttribute('data-action', 'back');
    btn.textContent = 'Back';
    return btn;
  };
  SF.makeHeading = function (text) {
    const h = document.createElement('h2');
    h.className = 'sf-title'; h.textContent = text;
    return h;
  };
  SF.makeSubtitle = function (text) {
    const p = document.createElement('p');
    p.className = 'sf-subtitle'; p.textContent = text;
    return p;
  };
  SF.makeStatusEl = function () {
    const el = document.createElement('div');
    el.className = 'sf-status-msg';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    return el;
  };
  SF.makeButton = function (text, action, className) {
    const cls = className || 'sf-btn';
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = cls;
    if (action) btn.setAttribute('data-action', action);
    btn.textContent = text;
    return btn;
  };
  SF.makeOption = function (icon, text, action, dataAttr) {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sf-option';
    if (action)   btn.setAttribute('data-action', action);
    if (dataAttr) btn.setAttribute(dataAttr.name, dataAttr.value);
    const iconEl = document.createElement('span');
    iconEl.className = 'sf-option-icon'; iconEl.textContent = icon;
    iconEl.setAttribute('aria-hidden', 'true');
    const textEl = document.createElement('span');
    textEl.textContent = text;
    btn.append(iconEl, textEl);
    return btn;
  };
  SF.makeOptionsContainer = function (marginTop) {
    const el = document.createElement('div');
    el.className = 'sf-options';
    if (marginTop) el.style.marginTop = marginTop;
    return el;
  };
  SF.makeLink = function (href, text, className) {
    const a = document.createElement('a');
    a.href = href; a.textContent = text;
    if (className) a.className = className;
    return a;
  };
  SF.makeTrackingPara = function (trackingUrl, trackingNumber) {
    const p    = document.createElement('p');
    const link = SF.makeLink(trackingUrl, 'Track your order', 'sf-link');
    link.target = '_blank'; link.rel = 'noopener';
    p.appendChild(link);
    if (trackingNumber) p.appendChild(document.createTextNode(' (' + trackingNumber + ')'));
    return p;
  };
  SF.makeOrderNamePara = function (prefix, orderName, suffix) {
    const p = document.createElement('p');
    p.className = 'sf-subtitle';
    if (prefix) p.appendChild(document.createTextNode(prefix));
    const strong = document.createElement('strong');
    strong.textContent = orderName || '';
    p.appendChild(strong);
    if (suffix) p.appendChild(document.createTextNode(suffix));
    return p;
  };
  SF.makeField = function (labelText, inputEl, optional) {
    const lbl = document.createElement('label');
    lbl.className = 'sf-label';
    lbl.style.cssText = 'display:block;margin-bottom:12px;';
    const span = document.createElement('span');
    span.style.cssText = 'display:block;margin-bottom:4px;font-weight:600;';
    span.textContent   = labelText;
    if (optional) {
      const opt = document.createElement('span');
      opt.className = 'sf-label-opt'; opt.textContent = ' (optional)';
      opt.style.fontWeight = 'normal';
      span.appendChild(opt);
    }
    lbl.appendChild(span); lbl.appendChild(inputEl);
    return lbl;
  };
  SF.makeInput = function (className, type, placeholder, value) {
    const el = document.createElement('input');
    el.className = 'sf-input ' + className; el.type = type;
    el.placeholder = placeholder; el.value = value || '';
    el.style.cssText = 'width:100%;box-sizing:border-box;font-family:inherit;padding:10px 12px;border:1px solid #d1d5db;border-radius:6px;';
    return el;
  };
  SF.makeTextarea = function (className, rows, placeholder, value) {
    const el = document.createElement('textarea');
    el.className = 'sf-input ' + className; el.rows = rows;
    el.placeholder = placeholder; el.value = value || '';
    el.style.cssText = 'width:100%;box-sizing:border-box;font-family:inherit;padding:10px 12px;border:1px solid #d1d5db;border-radius:6px;min-height:120px;resize:vertical;line-height:1.5;';
    return el;
  };
  SF.makeHintBox = function (text) {
    const box = document.createElement('div');
    box.className = 'sf-hint-box';
    box.style.cssText = 'display:flex;align-items:flex-start;gap:10px;background:#fffbea;border:1px solid #f5c842;border-left:4px solid #f5c842;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7a5c00;line-height:1.5;';
    const msg = document.createElement('span');
    msg.textContent = text;
    box.append(msg);
    return box;
  };
  SF.makeInfoBox = function (htmlOrText, isHtml) {
    const box = document.createElement('div');
    box.className = 'sf-info-box';
    box.style.cssText = 'display:flex;align-items:flex-start;gap:10px;background:#eef6ff;border:1px solid #90c8f8;border-left:4px solid #2196f3;border-radius:6px;padding:12px 14px;margin:16px 0;font-size:.92em;color:#0d3c61;line-height:1.5;';
    const msg = document.createElement('span');
    if (isHtml) msg.innerHTML = htmlOrText;
    else        msg.textContent = htmlOrText;
    box.append(msg);
    return box;
  };
  SF.makeProductIdentity = function (item) {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;align-items:center;gap:14px;margin:4px 0 16px;';
    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image; img.alt = '';
      img.style.cssText = 'width:64px;height:64px;object-fit:cover;border-radius:8px;flex-shrink:0;background:#f0f0f0;border:1px solid #e5e7eb;';
      img.setAttribute('aria-hidden', 'true');
      wrap.appendChild(img);
    }
    const text  = document.createElement('div');
    const title = document.createElement('p');
    title.style.cssText = 'margin:0;font-weight:600;font-size:.92em;line-height:1.3;color:#111;';
    title.textContent   = item.title;
    text.appendChild(title);
    if (item.variant_title) {
      const variant = document.createElement('p');
      variant.style.cssText = 'margin:2px 0 0;font-size:.85em;color:#6b7280;';
      variant.textContent   = item.variant_title;
      text.appendChild(variant);
    }
    wrap.appendChild(text);
    return wrap;
  };

  SF.mountUploader = function (container, opts) {
    const o = opts || {};
    const label = o.label || 'Attach files';
    const multiple = o.multiple !== false;
    if (!container) return { getKeys: function () { return []; }, isUploading: function () { return false; } };
    const frag  = SF.tpl('tpl-dropzone');
    const dz    = frag.querySelector('.sf-dropzone');
    const input = frag.querySelector('input[type="file"]');
    const btn   = frag.querySelector('.sf-attach-btn');
    const list  = frag.querySelector('.sf-file-list');
    if (btn) btn.textContent = label;
    if (multiple && input) input.setAttribute('multiple', '');
    container.innerHTML = '';
    container.appendChild(frag);
    let staged = [];
    function isUploading() { return staged.some(function (s) { return s.status === 'uploading'; }); }
    function render() {
      if (!list) return;
      list.innerHTML = '';
      staged.forEach(function (e, idx) {
        const row = document.createElement('div');
        row.className = 'sf-file-item';
        const name = document.createElement('span');
        name.textContent = e.file.name;
        const badge = document.createElement('span');
        badge.className = 'sf-file-badge ' + (e.status || '');
        badge.textContent = e.status === 'uploading' ? '...' : e.status === 'done' ? 'OK' : 'X';
        badge.setAttribute('aria-hidden', 'true');
        const del = document.createElement('button');
        del.type = 'button'; del.className = 'sf-file-del'; del.textContent = 'x';
        del.setAttribute('aria-label', 'Remove ' + e.file.name);
        del.addEventListener('click', function () { staged.splice(idx, 1); render(); });
        row.append(name, badge, del);
        list.appendChild(row);
      });
    }
    function uploadOne(entry) {
      const fd = new FormData();
      fd.append('file', entry.file);
      return fetch(SF.WORKER + '/upload', { method: 'POST', body: fd })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { return { res: res, data: data }; }); })
        .then(function (r) {
          if (!r.res.ok || !r.data.success) throw new Error(r.data.error || 'Upload failed');
          entry.key = r.data.key; entry.status = 'done';
        })
        .catch(function () { entry.status = 'error'; })
        .then(render);
    }
    function handleFiles(files) {
      for (let i = 0; i < files.length; i++) {
        if (staged.length >= 10) break;
        const f = files[i];
        staged.push({ file: f, key: null, status: 'uploading' });
        render();
        uploadOne(staged[staged.length - 1]);
      }
    }
    if (btn) btn.addEventListener('click', function () { input && input.click(); });
    if (input) input.addEventListener('change', function () { handleFiles([].slice.call(input.files || [])); input.value = ''; });
    if (dz) {
      dz.addEventListener('dragover', function (e) { e.preventDefault(); dz.classList.add('dragover'); });
      dz.addEventListener('dragleave', function () { dz.classList.remove('dragover'); });
      dz.addEventListener('drop', function (e) {
        e.preventDefault(); dz.classList.remove('dragover');
        handleFiles([].slice.call((e.dataTransfer && e.dataTransfer.files) || []));
      });
    }
    return {
      getKeys: function () { return staged.filter(function (s) { return s.key; }).map(function (s) { return s.key; }); },
      isUploading: isUploading
    };
  };

  SF.buildItemList = function (lineItems, selectedIds, onToggle) {
    const wrap = document.createElement('div');
    wrap.className = 'sf-item-list';
    lineItems.forEach(function (li) {
      const row = document.createElement('label');
      row.className = 'sf-item-check-row';
      row.style.cssText = 'display:flex;align-items:center;gap:12px;cursor:pointer;padding:10px 0;border-bottom:1px solid #f0f0f0;';
      const input = document.createElement('input');
      input.type = 'checkbox'; input.checked = selectedIds.has(String(li.id));
      input.addEventListener('change', function () { onToggle(li, input.checked); });
      const img = document.createElement('img');
      img.className = 'sf-item-thumb'; img.alt = '';
      img.style.cssText = 'width:48px;height:48px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#f0f0f0;';
      img.setAttribute('aria-hidden', 'true');
      if (li.image) { img.src = li.image; } else { img.style.display = 'none'; }
      const text = document.createElement('span');
      text.className   = 'sf-item-label';
      text.textContent = li.title + (li.variant_title ? ' - ' + li.variant_title : '');
      row.append(input, img, text);
      wrap.appendChild(row);
    });
    return wrap;
  };
  SF.buildOrderList = function (orders, selectedId, onSelect) {
    const group = document.createElement('div');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Select an order');
    orders.forEach(function (o) {
      const clone = SF.tpl('tpl-order-card');
      const card  = clone.querySelector('.sf-order-card') || clone.firstElementChild;
      if (!card) return;
      const isSelected = String(o.id) === String(selectedId);
      card.setAttribute('data-order-id', String(o.id));
      card.setAttribute('data-action', 'select-order-card');
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', String(isSelected));
      card.setAttribute('tabindex', isSelected ? '0' : '-1');
      card.querySelectorAll('*').forEach(function (el) {
        el.setAttribute('data-order-id', String(o.id));
        el.style.pointerEvents = 'none';
      });
      const nameEl  = card.querySelector('.sf-order-name');
      const metaEl  = card.querySelector('.sf-order-meta');
      const itemsEl = card.querySelector('.sf-order-items');
      if (nameEl)  nameEl.textContent  = o.name || '';
      if (metaEl)  metaEl.textContent  = SF.formatDate(o.created_at) + ' - ' + SF.fulfilLabel(o);
      if (itemsEl) itemsEl.textContent = (o.line_items ? o.line_items.length : 0) + ' item(s)';
      if (isSelected) card.classList.add('selected');
      // Click handling is delegated centrally (see the main click listener
      // below, which matches [data-action="select-order-card"]) rather than
      // attached directly here. A direct listener that triggers a full
      // re-render (via onSelect -> SF.renderStep -> SF.show -> innerHTML='')
      // mutates the DOM subtree while the click event is still bubbling
      // through it, which is unreliable across browsers. Keyboard handling
      // stays direct since it doesn't tear down the DOM mid-dispatch.
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(isSelected ? null : o); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          const next = card.nextElementSibling;
          if (next) { next.setAttribute('tabindex', '0'); next.focus(); card.setAttribute('tabindex', '-1'); }
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = card.previousElementSibling;
          if (prev) { prev.setAttribute('tabindex', '0'); prev.focus(); card.setAttribute('tabindex', '-1'); }
        }
      });
      group.appendChild(card);
    });
    return group;
  };
  SF.getContinueBtn = function (root) {
    return (
      root.querySelector('[data-action="confirm-orders"]') ||
      root.querySelector('.sf-continue-btn') ||
      [].slice.call(root.querySelectorAll('button,a,[role="button"]'))
        .find(function (b) { return (b.textContent || '').trim().toLowerCase() === 'continue'; })
    );
  };

  SF.buildTicketContext = function (extraLines) {
    const lines = extraLines || [];
    const a = SF.app;
    const out = ['--- Support Context ---'];
    out.push('Customer: ' + (SF.customerName  || '(unknown)'));
    out.push('Email:    ' + (SF.customerEmail || '(unknown)'));
    if (a.selectedOrder) {
      const o = a.selectedOrder;
      out.push('Order:    ' + o.name + ' (' + o.id + ')');
      out.push('Placed:   ' + SF.formatDate(o.created_at));
      out.push('Status:   ' + (o.fulfillment_status || 'unknown'));
      if (o.dispatched_at)   out.push('Dispatched:   ' + SF.formatDate(o.dispatched_at));
      if (o.tracking_number) out.push('Tracking #:   ' + o.tracking_number);
      if (o.tracking_url)    out.push('Tracking URL: ' + o.tracking_url);
    }
    if (a.issueType)       out.push('Issue type:        ' + a.issueType);
    if (a.deliverySubType) out.push('Delivery sub-type: ' + a.deliverySubType);
    if (a.missingItems && a.missingItems.length)
      out.push('Missing items: ' + a.missingItems.map(function (x) { return x.title; }).join(', '));
    if (a.damagedItems && a.damagedItems.length)
      out.push('Damaged items: ' + a.damagedItems.map(function (x) { return x.title; }).join(', '));
    if (a.contamItems && a.contamItems.length)
      out.push('Contaminated items: ' + a.contamItems.map(function (x) { return x.title; }).join(', '));
    if (a.productProblemItems && a.productProblemItems.length)
      out.push('Product problem items: ' + a.productProblemItems.map(function (x) { return x.title; }).join(', '));
    for (let i = 0; i < lines.length; i++) if (lines[i]) out.push(lines[i]);
    out.push('--- End Context ---');
    return out.join('\n');
  };
  SF.getWarningConfirmations = function (warningEl) {
    if (!warningEl) return '';
    var lines = [];
    warningEl.querySelectorAll('.sf-warning-block').forEach(function (block) {
      var cb = block.querySelector('.sf-warning-cb');
      if (cb && cb.checked) {
        var label = block.querySelector('.sf-warning-checkbox-wrap span');
        lines.push('✓ ' + (label ? label.textContent.trim() : 'Confirmed'));
      }
    });
    if (!lines.length) return '';
    return '\n\n--- User confirmations ---\n' + lines.join('\n');
  };
  SF.withContext = function (userMessage, extraLines) {
    return SF.buildTicketContext(extraLines) + '\n\n' + (userMessage || '(no message provided)');
  };
  SF.buildSubject = function () {
    const ord  = SF.app.selectedOrder;
    const name = (ord && ord.name) || '';
    const map  = {
      'missing-item':    name + ' had missing items',
      'damaged':         name + ' had damaged items',
      'not-arrived':     name + ' - delivery problem',
      'contaminated':    name + ' - contamination report',
      'product-problem': name + ' - product problem',
    };
    return 'Order ' + (map[SF.app.issueType] || (name ? name + ' - support request' : 'Support request'));
  };
  SF.buildMissingItemMessage = function () {
    const orderName = (SF.app.selectedOrder && SF.app.selectedOrder.name) || '';
    const itemLines = SF.app.missingItems.map(function (item, i) { return (i + 1) + '. ' + item.title; }).join('\n');
    return [
      'Hi MycoPunks team,', '',
      'Some items were missing from my order (' + orderName + ')', '',
      itemLines, '',
      'Can you let me know next steps?', '',
      'Thanks,', SF.customerFirst,
    ].join('\n');
  };
  SF.buildDeliveryNotReceivedMessage = function () {
    const orderName = (SF.app.selectedOrder && SF.app.selectedOrder.name) || '';
    return [
      'Hi MycoPunks team,', '',
      'Order ' + orderName + " says it was delivered, I've checked with neighbours and around my property and I can't find it.", '',
      'Please can you let me know next steps?', '',
      'Thanks,', SF.customerFirst,
    ].join('\n');
  };

  SF.submitContactForm = async function () {
    const submitBtn = SF.main.querySelector('[data-action="submit-contact"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }
    const resolvedName  = SF.isLoggedIn() ? (SF.customerName  || 'Customer') : ((SF.main.querySelector('.sf-cf-name') || {}).value || '').trim();
    const resolvedEmail = SF.isLoggedIn() ? (SF.customerEmail || '')         : ((SF.main.querySelector('.sf-cf-email') || {}).value || '').trim();
    const subject = ((SF.main.querySelector('.sf-cf-subject') || {}).value || '').trim();
    const message = ((SF.main.querySelector('.sf-cf-message') || {}).value || '').trim();
    const keys    = (SF.app.uploaders.contact && SF.app.uploaders.contact.getKeys()) || [];
    const tags    = (SF.app._contactTags || []).concat(SF.isLoggedIn() ? [] : ['unverified-guest']);
    function fail(msg) {
      SF.setStatus(msg, 'error');
      if (submitBtn && !submitBtn._sfWarningBlocked) { submitBtn.disabled = false; submitBtn.textContent = 'Create support ticket'; submitBtn.classList.remove('is-loading'); }
    }
    if (!resolvedName)  { fail('Please enter your name.');  return; }
    if (!resolvedEmail) { fail('Please enter your email.'); return; }
    if (!subject)       { fail('Please enter a subject.');  return; }
    if (!message)       { fail('Please enter a message.');  return; }
    // Keyword guard (belt-and-suspenders; UI should already block this)
    var _cfCombined = (subject + ' ' + message).toLowerCase();
    for (var _wi = 0; _wi < SF.TICKET_WARNINGS.length; _wi++) {
      var _wr = SF.TICKET_WARNINGS[_wi];
      if (_wr.preventSend === true && _wr.terms.some(function (t) { return _cfCombined.includes(t.toLowerCase()); })) {
        SF.setStatus(_wr.message, 'error');
        if (submitBtn) { submitBtn.disabled = true; submitBtn._sfWarningBlocked = true; submitBtn.textContent = submitBtn._sfOriginalText || 'Create support ticket'; submitBtn.classList.remove('is-loading'); }
        return;
      }
    }
    SF.setStatus('Sending...');
    try {
      await SF.apiPost('/tickets', {
        name: resolvedName, email: resolvedEmail, subject,
        message: SF.withContext(message) + SF.getWarningConfirmations(SF.main.querySelector('.sf-keyword-warning')), attachmentKeys: keys, tags,
      });
      SF.pushStep('success');
    } catch (e) { fail(e.message); }
  };
  SF.submitOther = async function () {
    const resolvedName  = SF.isLoggedIn() ? (SF.customerName  || 'Customer') : ((SF.main.querySelector('.sf-cf-name') || {}).value || '').trim();
    const resolvedEmail = SF.isLoggedIn() ? (SF.customerEmail || '')         : ((SF.main.querySelector('.sf-cf-email') || {}).value || '').trim();
    const subject = ((SF.main.querySelector('.sf-cf-subject') || {}).value || '').trim();
    const message = ((SF.main.querySelector('.sf-cf-message') || {}).value || '').trim();
    const keys    = (SF.app.uploaders.other && SF.app.uploaders.other.getKeys()) || [];
    if (!resolvedName)  { SF.setStatus('Please enter your name.',  'error'); return; }
    if (!resolvedEmail) { SF.setStatus('Please enter your email.', 'error'); return; }
    if (!subject)       { SF.setStatus('Please enter a subject.',  'error'); return; }
    if (!message)       { SF.setStatus('Please enter a message.',  'error'); return; }
    // Keyword guard
    var _otherCombined = (subject + ' ' + message).toLowerCase();
    for (var _wi = 0; _wi < SF.TICKET_WARNINGS.length; _wi++) {
      var _wr = SF.TICKET_WARNINGS[_wi];
      if (_wr.preventSend === true && _wr.terms.some(function (t) { return _otherCombined.includes(t.toLowerCase()); })) {
        SF.setStatus(_wr.message, 'error');
        return;
      }
    }
    SF.setStatus('Sending...');
    try {
      await SF.apiPost('/tickets', {
        name: resolvedName, email: resolvedEmail, subject,
        message: [
          '--- Support Context ---',
          'Customer: ' + (SF.customerName  || '(unknown)'),
          'Email:    ' + (SF.customerEmail || '(unknown)'),
          'Category: Other / general enquiry',
          '--- End Context ---', '', message + SF.getWarningConfirmations(SF.main.querySelector('.sf-keyword-warning')),
        ].join('\n'),
        attachmentKeys: keys, tags: SF.isLoggedIn() ? ['other'] : ['other', 'unverified-guest'],
      });
      SF.renderSuccess();
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitWebsite = async function () {
    const message = ((SF.main.querySelector('.sf-website-message') || {}).value || '').trim();
    const email   = SF.isLoggedIn() ? SF.customerEmail : ((SF.main.querySelector('.sf-website-email') || {}).value || '').trim();
    const keys    = (SF.app.uploaders.website && SF.app.uploaders.website.getKeys()) || [];
    if (!message) { SF.setStatus('Please describe the problem.', 'error'); return; }
    if (!email)   { SF.setStatus('Please enter your email so we can follow up.', 'error'); return; }
    SF.setStatus('Sending...');
    try {
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email,
        subject: 'Website problem report',
        message: [
          '--- Support Context ---',
          'Customer: ' + (SF.customerName || '(unknown)'),
          'Email:    ' + email,
          'Category: Website problem',
          '--- End Context ---', '', message,
        ].join('\n'),
        attachmentKeys: keys, tags: ['website'],
      });
      SF.renderSuccess();
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitDamaged = async function () {
    SF.setStatus('Submitting...');
    try {
      const userMsg    = ((SF.main.querySelector('.sf-extra-message') || {}).value || '').trim();
      const extraLines = ['Packaging damaged: ' + (SF.app.packagingDamaged ? 'Yes' : 'No')];
      SF.app.damagedItems.forEach(function (li) {
        const det = SF.app.damagedItemDetails[li.id] || {};
        extraLines.push('Damaged item: ' + li.title);
        if (det.description) extraLines.push('  Damage description: ' + det.description);
      });
      const detailKeys = [];
      Object.keys(SF.app.damagedItemDetails).forEach(function (k) {
        const d = SF.app.damagedItemDetails[k];
        if (d.attachmentKeys) detailKeys.push.apply(detailKeys, d.attachmentKeys);
      });
      const keys = (SF.app.parcelKeys || []).concat(detailKeys);
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email: SF.customerEmail || '',
        subject: 'Order ' + ((SF.app.selectedOrder && SF.app.selectedOrder.name) || '') + ' had damaged items',
        message: SF.withContext(userMsg, extraLines), attachmentKeys: keys,
        tags: ['order', 'issue:damaged'],
      });
      SF.pushStep('success');
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitContam = async function () {
    SF.setStatus('Submitting...');
    try {
      const notes      = ((SF.main.querySelector('.sf-contam-notes') || {}).value || '').trim();
      const extraLines = [];
      const allKeys    = [];
      SF.app.contamItems.forEach(function (item) {
        const det  = SF.app.contamDetails[item.id] || {};
        const uploader = SF.app.uploaders['contam_' + item.id];
        const keys = (uploader && uploader.getKeys()) || [];
        extraLines.push('Contaminated item: ' + item.title);
        if (det.lot)        extraLines.push('  Lot/date label: ' + det.lot);
        if (det.inoculated) extraLines.push('  Inoculated: '     + det.inoculated);
        allKeys.push.apply(allKeys, keys);
      });
      if (notes) extraLines.push('Additional notes: ' + notes);
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email: SF.customerEmail || '',
        subject: 'Order ' + ((SF.app.selectedOrder && SF.app.selectedOrder.name) || '') + ' - contamination report',
        message: SF.withContext('', extraLines), attachmentKeys: allKeys,
        tags: ['order', 'issue:contamination'],
      });
      SF.pushStep('success');
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitProductProblem = async function () {
    SF.setStatus('Submitting...');
    try {
      const extraLines = [];
      const allKeys    = [];
      SF.app.productProblemItems.forEach(function (item) {
        const det  = SF.app.productProblemDetails[item.id] || {};
        const uploader = SF.app.uploaders['product_' + item.id];
        const keys = (uploader && uploader.getKeys()) || [];
        extraLines.push('Product: ' + item.title);
        if (det.description) extraLines.push('  Issue: ' + det.description);
        allKeys.push.apply(allKeys, keys);
      });
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email: SF.customerEmail || '',
        subject: 'Order ' + ((SF.app.selectedOrder && SF.app.selectedOrder.name) || '') + ' - product problem',
        message: SF.withContext('', extraLines), attachmentKeys: allKeys,
        tags: ['order', 'issue:product-problem'],
      });
      SF.pushStep('success');
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };

  SF.renderSuccess = function () {
    const card = SF.makeCard();
    card.appendChild(SF.makeHeading('Request received'));
    card.appendChild(SF.makeSubtitle("We'll be in touch shortly via email."));
    card.appendChild(SF.makeInfoBox('Support is managed entirely via email. No need to create additional requests - simply reply to our email when you receive it.'));
    const actions = document.createElement('div');
    actions.style.cssText = 'display:flex;flex-direction:column;gap:8px;margin-top:18px;';
    actions.appendChild(SF.makeButton('Submit another ticket', 'restart-flow', 'sf-btn sf-btn--ghost'));
    actions.appendChild(SF.makeButton('Back to start', 'back-to-start', 'sf-btn sf-btn--ghost'));
    card.appendChild(actions);
    SF.show(card);
  };
  SF.renderNotLoggedIn = function () {
    const frag = SF.tpl('tpl-not-logged-in');
    const card = frag.querySelector('.sf-card') || frag.firstElementChild;
    if (!card) { SF.show(frag); return; }
    const returnHash   = SF.getTopHash() || 'order-problem';
    const loginUrl     = SF.buildLoginUrl(returnHash);
    const regAnchor    = card.querySelector('a[href*="register"]');
    const registerBase = (regAnchor && regAnchor.getAttribute('href') && regAnchor.getAttribute('href').split('?')[0]) || '/account/register';
    const signupUrl     = registerBase + '?return_to=' + encodeURIComponent('/pages/contact-support#' + returnHash);
    card.innerHTML = '';
    card.appendChild(SF.makeBackButton());
    card.appendChild(SF.makeHeading('Contact Support'));
    card.appendChild(SF.makeSubtitle('Please log in so we can pull up your orders.'));
    const info = document.createElement('div');
    info.className = 'sf-info-box';
    info.textContent = 'Log in using the email address associated with your order.';
    card.appendChild(info);
    card.appendChild(SF.makeLink(loginUrl, 'Log in to continue', 'sf-btn'));
    const guestNote = document.createElement('p');
    guestNote.style.cssText = 'margin-top:16px;font-size:.9em;color:#666;';
    guestNote.appendChild(document.createTextNode('Checked out as a guest? '));
    guestNote.appendChild(SF.makeLink(signupUrl, 'Create an account', 'sf-link'));
    guestNote.appendChild(document.createTextNode(' using the email used for your order.'));
    card.appendChild(guestNote);
    SF.show(frag);
  };
  SF.renderContactForm = function (opts) {
    const o = opts || {};
    const card         = SF.makeCard();
    const uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'sf-cf-uploader-wrap';
    card.appendChild(SF.makeBackButton());
    card.appendChild(SF.makeHeading('Contact Support'));
    card.appendChild(SF.makeSubtitle("Fill in the details below and we'll get back to you via email."));
    card.appendChild(SF.makeStatusEl());
    if (!SF.isLoggedIn()) {
      card.appendChild(SF.makeField('Name',  SF.makeInput('sf-cf-name',  'text',  'Your name',  SF.customerName)));
      card.appendChild(SF.makeField('Email', SF.makeInput('sf-cf-email', 'email', 'Your email', SF.customerEmail)));
    }
    var cfSubjectEl = SF.makeInput('sf-cf-subject', 'text', "What's it about?", o.subject || '');
    card.appendChild(SF.makeField('Subject', cfSubjectEl));
    var cfMessageEl = SF.makeTextarea('sf-cf-message', 10, 'Tell us more...', o.message || '');
    card.appendChild(SF.makeField('Message', cfMessageEl));
    var cfWarningEl = document.createElement('div');
    cfWarningEl.className = 'sf-keyword-warning';
    cfWarningEl.style.cssText = 'display:none;background:#fff0f0;border:1px solid #f5a0a0;border-left:4px solid #e53e3e;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7b1c1c;line-height:1.5;';
    card.appendChild(cfWarningEl);
    var cfSubmitBtn = SF.makeButton('Create support ticket', 'submit-contact');
    card.appendChild(uploaderWrap);
    card.appendChild(cfSubmitBtn);
    function cfCheckWarnings() {
      var combined = { value: (cfSubjectEl.value || '') + ' ' + (cfMessageEl.value || '') };
      SF.checkTicketWarnings(combined, cfWarningEl, cfSubmitBtn);
    }
    cfSubjectEl.addEventListener('input', cfCheckWarnings);
    cfMessageEl.addEventListener('input', cfCheckWarnings);
    SF.app.uploaders.contact = SF.mountUploader(uploaderWrap, { label: 'Attach files' });
    SF.app._contactTags      = o.tags || [];
    SF.show(card);
  };
  SF.renderOtherForm = function () {
    const card         = SF.makeCard();
    const uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'sf-cf-uploader-wrap';
    card.appendChild(SF.makeBackButton());
    card.appendChild(SF.makeHeading('Get in touch'));
    card.appendChild(SF.makeSubtitle("Fill in the form below and we'll get back to you via email."));
    card.appendChild(SF.makeStatusEl());
    if (!SF.isLoggedIn()) {
      card.appendChild(SF.makeField('Name',  SF.makeInput('sf-cf-name',  'text',  'Your name',  SF.customerName)));
      card.appendChild(SF.makeField('Email', SF.makeInput('sf-cf-email', 'email', 'Your email', SF.customerEmail)));
    }
    var otherSubjectEl = SF.makeInput('sf-cf-subject', 'text', "What's it about?");
    card.appendChild(SF.makeField('Subject', otherSubjectEl));
    var otherMessageEl = SF.makeTextarea('sf-cf-message', 10, 'Tell us more...');
    card.appendChild(SF.makeField('Message', otherMessageEl));
    var otherWarningEl = document.createElement('div');
    otherWarningEl.className = 'sf-keyword-warning';
    otherWarningEl.style.cssText = 'display:none;background:#fff0f0;border:1px solid #f5a0a0;border-left:4px solid #e53e3e;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7b1c1c;line-height:1.5;';
    card.appendChild(otherWarningEl);
    var otherSubmitBtn = SF.makeButton('Create support ticket', 'submit-other');
    card.appendChild(uploaderWrap);
    card.appendChild(otherSubmitBtn);
    function otherCheckWarnings() {
      var combined = { value: (otherSubjectEl.value || '') + ' ' + (otherMessageEl.value || '') };
      SF.checkTicketWarnings(combined, otherWarningEl, otherSubmitBtn);
    }
    otherSubjectEl.addEventListener('input', otherCheckWarnings);
    otherMessageEl.addEventListener('input', otherCheckWarnings);
    SF.app.uploaders.other = SF.mountUploader(uploaderWrap, { label: 'Attach files' });
    SF.show(card);
  };

  SF.renderStep = function () {
    SF.debugLog('step=' + SF.app.step);
    const app = SF.app;
    try {
      switch (app.step) {

        case 'issue': {
          const frag    = SF.tpl('tpl-choose-issue');
          const heading = frag.querySelector('.sf-title, h2, h1');
          if (heading) heading.textContent = 'How can we help?';
          SF.show(frag);
          break;
        }

        case 'select-order': {
          const frag    = SF.tpl('tpl-select-orders');
          const heading = frag.querySelector('.sf-title, h2, h1');
          const headingMap = {
            'missing-item':    'Which order had missing items?',
            'damaged':         'Which order had damaged items?',
            'not-arrived':     'Which order had a delivery problem?',
            'contaminated':    'Which order had contaminated products?',
            'product-problem': 'Which order has the product problem?',
          };
          if (heading) heading.textContent = headingMap[app.issueType] || 'Which order number was affected?';
          const list = frag.querySelector('#sf-order-list');
          if (!list) throw new Error('tpl-select-orders missing #sf-order-list');
          list.innerHTML = '';
          list.appendChild(SF.buildOrderList(
            app.orders,
            app.selectedOrder ? String(app.selectedOrder.id) : null,
            function (o) { app.selectedOrder = o; SF.renderStep(); }
          ));

          if (app.ordersMode === 'recent' && (app.ordersHasMore || app.ordersLoadingAll)) {
            const showAllWrap = document.createElement('div');
            showAllWrap.style.cssText = 'margin-top:12px;text-align:center;';
            const showAllBtn = document.createElement('button');
            showAllBtn.type = 'button';
            showAllBtn.className = 'sf-link sf-link-btn';
            showAllBtn.textContent = app.ordersLoadingAll ? 'Loading...' : 'Show all orders';
            if (app.ordersLoadingAll) {
              showAllBtn.classList.add('is-loading');
              showAllBtn.disabled = true;
            } else {
              showAllBtn.setAttribute('data-action', 'show-all-orders');
            }
            showAllWrap.appendChild(showAllBtn);
            list.parentNode.insertBefore(showAllWrap, list.nextSibling);
          }

          const cont = SF.getContinueBtn(frag);
          if (cont) cont.disabled = !app.selectedOrder;
          SF.show(frag);
          break;
        }

        case 'delivery-type': {
          const card = SF.makeCard();
          const opts = SF.makeOptionsContainer();
          opts.appendChild(SF.makeOption('', "My order still hasn't arrived",                null, { name: 'data-delivery', value: 'not-received' }));
          opts.appendChild(SF.makeOption('', "Tracking says delivered, but I don't have it", null, { name: 'data-delivery', value: 'wrong-address' }));
          opts.appendChild(SF.makeOption('', 'Other delivery problem',                        null, { name: 'data-delivery', value: 'other' }));
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('What happened with your delivery?'));
          card.appendChild(SF.makeSubtitle('Select the option that best describes your issue.'));
          card.appendChild(opts);
          SF.show(card);
          break;
        }

        case 'delivery-info': {
          const o    = app.selectedOrder;
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Order status'));
          if (o.cancelled_at) {
            const p = document.createElement('p');
            p.className = 'sf-subtitle';
            p.textContent = 'This order was cancelled, so it was never dispatched. If you believe this is a mistake, get in touch and we will look into it.';
            card.appendChild(p);
            card.appendChild(SF.makeButton('Contact support about this order', 'delivery-force-contact'));
            SF.show(card);
            break;
          }
          if (!o.dispatched_at) {
            const p = document.createElement('p');
            p.className = 'sf-subtitle';
            p.innerHTML = 'Your order is still being prepared by our team. To get an idea of how long things might be, you can check our <a href="/pages/service-lead-times" class="sf-link">lead times page</a>.';
            card.appendChild(p);
            SF.show(card);
            break;
          }
          const days = o.working_days_since_dispatch || 0;
          card.appendChild(SF.makeOrderNamePara('Order ', o.name, ' was dispatched on ' + SF.formatDate(o.dispatched_at) + '.'));
          if (o.tracking_url) card.appendChild(SF.makeTrackingPara(o.tracking_url, o.tracking_number));
          card.appendChild(SF.makeStatusEl());
          if (days < 4) {
            card.appendChild(SF.makeHintBox('It has only been ' + days + ' working day' + (days !== 1 ? 's' : '') + ' since we shipped your order. Please allow a little more time for it to arrive before raising a case.'));
            card.appendChild(SF.makeButton('I think there is a problem with the delivery', 'delivery-force-contact', 'sf-btn sf-btn--ghost'));
          } else {
            const opts = SF.makeOptionsContainer('16px');
            opts.appendChild(SF.makeOption('', "I still haven't received it", 'delivery-still-missing'));
            card.appendChild(opts);
          }
          SF.show(card);
          break;
        }

        case 'delivery-roadblock': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Before we raise a case...'));
          card.appendChild(SF.makeHintBox('Sometimes couriers will leave items with neighbours or in a "safe place" - please check around your property and with nearby neighbours before continuing.'));
          card.appendChild(SF.makeStatusEl());
          const opts = SF.makeOptionsContainer('16px');
          opts.appendChild(SF.makeOption('', "I've checked and still can't find it", 'delivery-still-missing'));
          card.appendChild(opts);
          SF.show(card);
          break;
        }

        case 'delivery-message':
          SF.renderContactForm({
            subject: SF.buildSubject(),
            message: SF.buildDeliveryNotReceivedMessage(),
            tags:    ['order', 'issue:delivery', 'subtype:not-received'],
          });
          break;

        case 'missing-item': {
          const frag    = SF.tpl('tpl-missing-item-new');
          const heading = frag.querySelector('.sf-title, h2, h1');
          if (heading) heading.textContent = 'Which items were missing in the order?';
          const list = frag.querySelector('.sf-item-list');
          if (!list) throw new Error('tpl-missing-item-new missing .sf-item-list');
          list.parentNode.insertBefore(SF.makeHintBox('Sometimes smaller items can get lost in amongst the packaging - make sure to check in the void fill paper.'), list);
          const selectedIds = new Set(app.missingItems.map(function (x) { return String(x.id); }));
          list.replaceWith(SF.buildItemList((app.selectedOrder && app.selectedOrder.line_items) || [], selectedIds, function (li, checked) {
            if (checked) { if (!app.missingItems.some(function (x) { return String(x.id) === String(li.id); })) app.missingItems.push(li); }
            else { app.missingItems = app.missingItems.filter(function (x) { return String(x.id) !== String(li.id); }); }
          }));
          SF.show(frag);
          break;
        }

        case 'damaged-packaging':
          SF.show(SF.tpl('tpl-damaged-packaging'));
          break;

        case 'damaged-items': {
          const frag = SF.tpl('tpl-damaged-items');
          if (app.packagingDamaged) {
            app.uploaders.parcel = SF.mountUploader(frag.querySelector('.sf-parcel-uploader'), { label: 'Upload parcel photo' });
          } else {
            const uploadBlock = frag.querySelector('.sf-parcel-uploader');
            const block = uploadBlock ? uploadBlock.closest('.sf-upload-block') : null;
            if (block) block.remove();
          }
          const list = frag.querySelector('.sf-item-list');
          if (!list) throw new Error('tpl-damaged-items missing .sf-item-list');
          const selectedIds = new Set(app.damagedItems.map(function (x) { return String(x.id); }));
          list.replaceWith(SF.buildItemList((app.selectedOrder && app.selectedOrder.line_items) || [], selectedIds, function (li, checked) {
            if (checked) { if (!app.damagedItems.some(function (x) { return String(x.id) === String(li.id); })) app.damagedItems.push(li); }
            else { app.damagedItems = app.damagedItems.filter(function (x) { return String(x.id) !== String(li.id); }); }
          }));
          SF.show(frag);
          break;
        }

        case 'damaged-item-detail': {
          const item = app.damagedItems[app.damagedIdx];
          if (!item) { SF.pushStep('damaged-extra'); return; }
          const frag    = SF.tpl('tpl-damaged-item-detail');
          const stepEl  = frag.querySelector('.sf-damaged-step');
          if (stepEl) stepEl.textContent = 'Item ' + (app.damagedIdx + 1) + ' of ' + app.damagedItems.length;
          const titleEl    = frag.querySelector('.sf-damaged-item-title');
          const identityEl = SF.makeProductIdentity(item);
          if (titleEl) titleEl.replaceWith(identityEl);
          else { const c = frag.querySelector('.sf-card'); if (c) c.prepend(identityEl); }
          app.uploaders.item = SF.mountUploader(frag.querySelector('.sf-damaged-item-uploader'), { label: 'Upload item photo(s)' });
          const existing = app.damagedItemDetails[item.id];
          const desc     = frag.querySelector('.sf-damaged-item-desc');
          if (desc && existing && existing.description) desc.value = existing.description;
          SF.show(frag);
          if (desc) {
            var damagedItemWarningEl = document.createElement('div');
            damagedItemWarningEl.className = 'sf-keyword-warning';
            damagedItemWarningEl.style.cssText = 'display:none;background:#fff0f0;border:1px solid #f5a0a0;border-left:4px solid #e53e3e;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7b1c1c;line-height:1.5;';
            desc.closest('.sf-field') ? desc.closest('.sf-field').after(damagedItemWarningEl) : desc.parentNode.insertBefore(damagedItemWarningEl, desc.nextSibling);
            var damagedItemNextBtn = SF.main.querySelector('[data-action="damaged-item-next"]');
            desc.addEventListener('input', function () {
              SF.checkTicketWarnings(desc, damagedItemWarningEl, damagedItemNextBtn);
            });
          }
          break;
        }

        case 'damaged-extra': {
          SF.show(SF.tpl('tpl-damaged-extra'));
          var damagedExtraTextarea = SF.main.querySelector('.sf-extra-message');
          if (damagedExtraTextarea) {
            var damagedExtraWarningEl = document.createElement('div');
            damagedExtraWarningEl.className = 'sf-keyword-warning';
            damagedExtraWarningEl.style.cssText = 'display:none;background:#fff0f0;border:1px solid #f5a0a0;border-left:4px solid #e53e3e;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7b1c1c;line-height:1.5;';
            damagedExtraTextarea.closest('.sf-field') ? damagedExtraTextarea.closest('.sf-field').after(damagedExtraWarningEl) : damagedExtraTextarea.parentNode.insertBefore(damagedExtraWarningEl, damagedExtraTextarea.nextSibling);
            var damagedExtraSubmitBtn = SF.main.querySelector('[data-action="submit-damaged"]');
            damagedExtraTextarea.addEventListener('input', function () {
              SF.checkTicketWarnings(damagedExtraTextarea, damagedExtraWarningEl, damagedExtraSubmitBtn);
            });
          }
          break;
        }

        case 'contam-select': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Which products contaminated?'));
          card.appendChild(SF.makeSubtitle('Select all affected items from your order.'));
          card.appendChild(SF.makeStatusEl());
          const selectedIds = new Set(app.contamItems.map(function (x) { return String(x.id); }));
          card.appendChild(SF.buildItemList((app.selectedOrder && app.selectedOrder.line_items) || [], selectedIds, function (li, checked) {
            if (checked) { if (!app.contamItems.some(function (x) { return String(x.id) === String(li.id); })) app.contamItems.push(li); }
            else { app.contamItems = app.contamItems.filter(function (x) { return String(x.id) !== String(li.id); }); }
          }));
          card.appendChild(SF.makeButton("That's everything", 'contam-items-next'));
          SF.show(card);
          break;
        }

        case 'contam-detail': {
          const item = app.contamItems[app.contamIdx];
          if (!item) { SF.pushStep('contam-submit'); return; }
          const existing = app.contamDetails[item.id] || {};
          const card     = SF.makeCard();
          const stepEl   = document.createElement('p');
          stepEl.className   = 'sf-subtitle';
          stepEl.textContent = 'Item ' + (app.contamIdx + 1) + ' of ' + app.contamItems.length;
          card.appendChild(SF.makeBackButton());
          card.appendChild(stepEl);
          card.appendChild(SF.makeProductIdentity(item));
          card.appendChild(SF.makeStatusEl());
          const lotInput = SF.makeInput('sf-contam-lot', 'text', 'e.g. LOT-1234 or 2024-03-15', existing.lot || '');
          card.appendChild(SF.makeField('Lot number or date label', lotInput));
          card.appendChild(SF.makeHintBox('The lot number or date label can be found printed on the bag label.'));
          const ynWrap = document.createElement('div');
          ynWrap.style.cssText = 'margin-bottom:14px;';
          const ynLabel = document.createElement('p');
          ynLabel.style.cssText = 'font-weight:600;margin:0 0 8px;';
          ynLabel.textContent   = 'Did you inoculate this product?';
          ynWrap.appendChild(ynLabel);
          const ynBtns = document.createElement('div');
          ynBtns.className     = 'sf-yn-btns';
          ynBtns.style.cssText = 'display:flex;gap:10px;';
          ['Yes', 'No'].forEach(function (val) {
            const btn = document.createElement('button');
            btn.type          = 'button';
            btn.className     = 'sf-yn-btn';
            btn.textContent   = val;
            btn.style.cssText = 'padding:8px 24px;border-radius:6px;border:1px solid #d1d5db;background:#fff;cursor:pointer;font-family:inherit;font-size:1em;transition:all .15s;';
            if (existing.inoculated === val) {
              btn.style.background  = '#111';
              btn.style.color       = '#fff';
              btn.style.borderColor = '#111';
              ynBtns.dataset.value  = val;
            }
            ynBtns.appendChild(btn);
          });
          ynWrap.appendChild(ynBtns);
          card.appendChild(ynWrap);
          const uploaderWrap     = document.createElement('div');
          uploaderWrap.className = 'sf-contam-uploader-wrap';
          card.appendChild(SF.makeField('Photos of the contamination', uploaderWrap));
          app.uploaders['contam_' + item.id] = SF.mountUploader(uploaderWrap, { label: 'Upload photos' });
          card.appendChild(SF.makeButton(
            app.contamIdx < app.contamItems.length - 1 ? 'Continue to next item' : 'Review and submit',
            'contam-detail-next'
          ));
          SF.show(card);
          break;
        }

        case 'contam-submit': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Anything else to add?'));
          card.appendChild(SF.makeSubtitle('Optional - add any extra details that might help us.'));
          card.appendChild(SF.makeStatusEl());
          const contamNotesEl = SF.makeTextarea('sf-contam-notes', 5, 'Any other details...');
          card.appendChild(SF.makeField('Additional notes', contamNotesEl, true));
          var contamWarningEl = document.createElement('div');
          contamWarningEl.className = 'sf-keyword-warning';
          contamWarningEl.style.cssText = 'display:none;background:#fff0f0;border:1px solid #f5a0a0;border-left:4px solid #e53e3e;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7b1c1c;line-height:1.5;';
          card.appendChild(contamWarningEl);
          var contamSubmitBtn = SF.makeButton('Create support ticket', 'submit-contam');
          card.appendChild(contamSubmitBtn);
          SF.show(card);
          contamNotesEl.addEventListener('input', function () {
            SF.checkTicketWarnings(contamNotesEl, contamWarningEl, contamSubmitBtn);
          });
          break;
        }

        case 'product-select': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Which item(s) have a problem?'));
          card.appendChild(SF.makeSubtitle('Select all affected items from your order.'));
          card.appendChild(SF.makeStatusEl());
          const selectedIds = new Set(app.productProblemItems.map(function (x) { return String(x.id); }));
          card.appendChild(SF.buildItemList((app.selectedOrder && app.selectedOrder.line_items) || [], selectedIds, function (li, checked) {
            if (checked) { if (!app.productProblemItems.some(function (x) { return String(x.id) === String(li.id); })) app.productProblemItems.push(li); }
            else { app.productProblemItems = app.productProblemItems.filter(function (x) { return String(x.id) !== String(li.id); }); }
          }));
          card.appendChild(SF.makeButton("That's everything", 'product-items-next'));
          SF.show(card);
          break;
        }

        case 'product-detail': {
          const item = app.productProblemItems[app.productProblemIdx];
          if (!item) { SF.submitProductProblem(); return; }
          const existing = app.productProblemDetails[item.id] || {};
          const card     = SF.makeCard();
          const stepEl   = document.createElement('p');
          stepEl.className   = 'sf-subtitle';
          stepEl.textContent = 'Item ' + (app.productProblemIdx + 1) + ' of ' + app.productProblemItems.length;
          card.appendChild(SF.makeBackButton());
          card.appendChild(stepEl);
          card.appendChild(SF.makeProductIdentity(item));
          card.appendChild(SF.makeStatusEl());
          const issueArea = SF.makeTextarea('sf-product-issue-desc', 5, 'Describe the issue with this item...', existing.description || '');
          card.appendChild(SF.makeField('What is the issue with this item?', issueArea));
          var productWarningEl = document.createElement('div');
          productWarningEl.className = 'sf-keyword-warning';
          productWarningEl.style.cssText = 'display:none;background:#fff0f0;border:1px solid #f5a0a0;border-left:4px solid #e53e3e;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7b1c1c;line-height:1.5;';
          card.appendChild(productWarningEl);
          const uploaderWrap     = document.createElement('div');
          uploaderWrap.className = 'sf-product-uploader-wrap';
          card.appendChild(SF.makeField('Photos', uploaderWrap, true));
          app.uploaders['product_' + item.id] = SF.mountUploader(uploaderWrap, { label: 'Upload photos' });
          var productDetailNextBtn = SF.makeButton(
            app.productProblemIdx < app.productProblemItems.length - 1 ? 'Continue to next item' : 'Create support ticket',
            'product-detail-next'
          );
          card.appendChild(productDetailNextBtn);
          SF.show(card);
          issueArea.addEventListener('input', function () {
            SF.checkTicketWarnings(issueArea, productWarningEl, productDetailNextBtn);
          });
          break;
        }

        case 'contact-form':
          SF.renderContactForm({
            subject: SF.buildSubject(),
            message: app.issueType === 'missing-item' && app.missingItems.length
              ? SF.buildMissingItemMessage() : '',
            tags: ['order', app.issueType || ''].filter(Boolean),
          });
          break;

        case 'success':
          SF.renderSuccess();
          break;

        default:
          SF.show(SF.tpl('tpl-choose-issue'));
      }
    } catch (err) { SF.renderFatal(err); }
  };

  SF.renderTop = function () {
    const top = SF.getTopHash();
    SF.app.top = top;
    SF.debugLog('top=' + (top || '(home)'));
    switch (top) {
      case '':
        SF.show(SF.tpl('tpl-choose-category'));
        return;
      case 'cultivation':
        SF.show(SF.hasTpl('tpl-cultivation') ? SF.tpl('tpl-cultivation') : SF.tpl('tpl-choose-category'));
        return;
      case 'website':
        if (SF.hasTpl('tpl-website-problem')) {
          const f = SF.tpl('tpl-website-problem');
          if (SF.isLoggedIn()) {
            const emailField = f.querySelector('.sf-website-email');
            const emailWrap  = emailField ? emailField.closest('.sf-field') : null;
            if (emailWrap) emailWrap.remove();
          }
          SF.app.uploaders.website = SF.mountUploader(f.querySelector('.sf-website-uploader'), { label: 'Attach screenshots' });
          SF.show(f);
        } else {
          SF.show(SF.tpl('tpl-choose-category'));
        }
        return;
      case 'other':
        SF.renderOtherForm();
        return;
      case 'order-problem':
        if (!SF.isLoggedIn()) { SF.renderNotLoggedIn(); return; }
        SF.resetFlow();
        SF.renderStep();
        return;
    }
  };

  window.addEventListener('hashchange', function () {
    try { SF.renderTop(); } catch (err) { SF.renderFatal(err); }
  });

  SF.main.addEventListener('submit', function (e) { e.preventDefault(); }, true);

  SF.main.addEventListener('click', async function (e) {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const app = SF.app;

    // Guard every "submit-*" action button against double-clicks / rapid
    // re-clicks while a submission is in flight. This covers all five
    // ticket-creation paths centrally rather than needing a per-function fix.
    const submitBtn = t.closest('[data-action^="submit-"]');
    if (submitBtn) {
      if (submitBtn.disabled) return;
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      submitBtn._sfOriginalText = submitBtn.textContent;
      submitBtn.textContent = 'Sending...';
    }

    const ynBtn = t.closest('.sf-yn-btn');
    if (ynBtn) {
      const group = ynBtn.closest('.sf-yn-btns');
      if (group) {
        group.querySelectorAll('.sf-yn-btn').forEach(function (b) {
          b.style.background  = '#fff';
          b.style.color       = '#111';
          b.style.borderColor = '#d1d5db';
          delete b.dataset.selected;
        });
        ynBtn.style.background  = '#111';
        ynBtn.style.color       = '#fff';
        ynBtn.style.borderColor = '#111';
        ynBtn.dataset.selected  = 'true';
        group.dataset.value     = ynBtn.textContent.trim();
      }
      return;
    }

    if (t.closest('[data-action="back-to-start"]')) {
      SF.goTop('');
      return;
    }

    if (t.closest('[data-action="restart-flow"]')) {
      if (app.top === 'order-problem') {
        SF.resetFlow();
        SF.renderStep();
      } else if (app.top === 'website') {
        SF.renderTop();
      } else if (app.top === 'other') {
        SF.renderOtherForm();
      } else {
        SF.goTop('');
      }
      return;
    }

    if (t.closest('[data-action="back"],.sf-back')) {
      if (app.top === 'order-problem' && app.stepStack.length > 0) SF.popStep();
      else SF.goTop('');
      return;
    }

    const cat = t.closest('[data-category]');
    if (cat) {
      const v = (cat.getAttribute('data-category') || '').toLowerCase();
      SF.goTop(
        v === 'order-problem' ? 'order-problem' :
        v === 'website'       ? 'website'       :
        v === 'cultivation'   ? 'cultivation'   :
        v === 'other'         ? 'other' : ''
      );
      return;
    }

    if (t.closest('[data-action="show-other-form"]')) {
      app.top = 'other';
      SF.renderOtherForm();
      return;
    }

    if (t.closest('[data-action="submit-other"]'))   { await SF.submitOther();       return; }
    if (t.closest('[data-action="submit-contact"]')) { await SF.submitContactForm(); return; }
    if (t.closest('[data-action="submit-website"]')) { await SF.submitWebsite();     return; }

    if (app.top !== 'order-problem') return;

    const issue = t.closest('[data-issue]');
    if (issue) {
      const allIssueOptions = SF.main.querySelectorAll('[data-issue]');
      allIssueOptions.forEach((opt) => { opt.disabled = true; });
      issue.classList.add('is-loading');
      const spinner = document.createElement('span');
      spinner.className = 'sf-spinner sf-spinner--inline';
      spinner.setAttribute('aria-hidden', 'true');
      issue.appendChild(spinner);
      app.issueType = (issue.getAttribute('data-issue') || '').toLowerCase();
      try { await SF.loadOrders(); } catch (err) { SF.renderFatal(err); return; }
      SF.pushStep('select-order');
      return;
    }

    if (app.step === 'select-order') {
      const orderCard = t.closest('[data-action="select-order-card"]');
      if (orderCard) {
        const clickedId = orderCard.getAttribute('data-order-id');
        const alreadySelected = app.selectedOrder && String(app.selectedOrder.id) === String(clickedId);
        app.selectedOrder = alreadySelected
          ? null
          : (app.orders.find(function (o) { return String(o.id) === String(clickedId); }) || null);
        SF.renderStep();
        return;
      }
      if (t.closest('[data-action="show-all-orders"]')) {
        await SF.loadAllOrders();
        return;
      }
      const btn = t.closest('[data-action="confirm-orders"]');
      if (btn) {
        if (!app.selectedOrder) return;
        const nextStepMap = {
          'not-arrived':     'delivery-type',
          'missing-item':    'missing-item',
          'damaged':         'damaged-packaging',
          'contaminated':    'contam-select',
          'product-problem': 'product-select',
        };
        SF.pushStep(nextStepMap[app.issueType] || 'contact-form');
        return;
      }
    }

    if (app.step === 'delivery-type') {
      const btn = t.closest('[data-delivery]');
      if (btn) {
        app.deliverySubType = btn.getAttribute('data-delivery');
        if (app.deliverySubType === 'other') {
          SF.pushStep('contact-form');
        } else if (app.deliverySubType === 'wrong-address') {
          SF.pushStep('delivery-roadblock');
        } else {
          SF.pushStep('delivery-info');
        }
        return;
      }
    }

    if (app.step === 'delivery-info') {
      if (t.closest('[data-action="delivery-still-missing"]')) {
        SF.pushStep('delivery-roadblock');
        return;
      }
      if (t.closest('[data-action="delivery-contact"]')) {
        SF.pushStep('contact-form');
        return;
      }
      if (t.closest('[data-action="delivery-force-contact"]')) {
        SF.renderContactForm({
          subject: 'Order ' + ((app.selectedOrder && app.selectedOrder.name) || '') + ' delivery issue',
          message: '',
          tags:    ['order', 'issue:delivery', 'subtype:early-contact'],
        });
        return;
      }
    }

    if (app.step === 'delivery-roadblock') {
      if (t.closest('[data-action="delivery-still-missing"]')) {
        SF.pushStep('delivery-message');
        return;
      }
    }

    if (app.step === 'missing-item') {
      const btn = t.closest('[data-action="missing-item-next"]');
      if (btn) {
        if (!app.missingItems.length) { SF.setStatus('Please select at least one missing item.', 'error'); return; }
        SF.pushStep('contact-form');
        return;
      }
    }

    if (app.step === 'damaged-packaging') {
      const pkg = t.closest('[data-packaging]');
      if (pkg) {
        app.packagingDamaged = pkg.getAttribute('data-packaging') === 'true';
        SF.pushStep('damaged-items');
        return;
      }
    }

    if (app.step === 'damaged-items') {
      const btn = t.closest('[data-action="damaged-items-next"]');
      if (btn) {
        if (app.uploaders.parcel && app.uploaders.parcel.isUploading()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        app.parcelKeys = (app.uploaders.parcel && app.uploaders.parcel.getKeys()) || [];
        if (app.packagingDamaged && !app.parcelKeys.length) { SF.setStatus('Please upload a photo of the damaged parcel.', 'error'); return; }
        if (!app.damagedItems.length) { SF.setStatus('Please select which item(s) were damaged.', 'error'); return; }
        app.damagedIdx = 0;
        SF.pushStep('damaged-item-detail');
        return;
      }
    }

    if (app.step === 'damaged-item-detail') {
      const btn = t.closest('[data-action="damaged-item-next"]');
      if (btn) {
        const item = app.damagedItems[app.damagedIdx];
        if (!item) { SF.pushStep('damaged-extra'); return; }
        if (app.uploaders.item && app.uploaders.item.isUploading()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys = (app.uploaders.item && app.uploaders.item.getKeys()) || [];
        const desc = ((SF.main.querySelector('.sf-damaged-item-desc') || {}).value || '').trim();
        if (!keys.length) { SF.setStatus('Please upload at least one photo.', 'error'); return; }
        if (!desc)        { SF.setStatus('Please describe the damage.',        'error'); return; }
        app.damagedItemDetails[item.id] = { attachmentKeys: keys, description: desc };
        app.damagedIdx += 1;
        if (app.damagedIdx >= app.damagedItems.length) SF.pushStep('damaged-extra');
        else SF.renderStep();
        return;
      }
    }

    if (app.step === 'damaged-extra') {
      if (t.closest('[data-action="submit-damaged"]')) {
        await SF.submitDamaged();
        return;
      }
    }

    if (app.step === 'contam-select') {
      if (t.closest('[data-action="contam-items-next"]')) {
        if (!app.contamItems.length) { SF.setStatus('Please select at least one item.', 'error'); return; }
        app.contamIdx = 0;
        SF.pushStep('contam-detail');
        return;
      }
    }

    if (app.step === 'contam-detail') {
      if (t.closest('[data-action="contam-detail-next"]')) {
        const item = app.contamItems[app.contamIdx];
        if (!item) { SF.pushStep('contam-submit'); return; }
        const uploader   = app.uploaders['contam_' + item.id];
        if (uploader && uploader.isUploading()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys       = (uploader && uploader.getKeys()) || [];
        const lot        = ((SF.main.querySelector('.sf-contam-lot') || {}).value || '').trim();
        const ynEl       = SF.main.querySelector('.sf-yn-btns');
        const inoculated = (ynEl && ynEl.dataset && ynEl.dataset.value) || '';
        if (!lot)         { SF.setStatus('Please enter the lot number or date label.',            'error'); return; }
        if (!inoculated)  { SF.setStatus('Please indicate whether this product was inoculated.', 'error'); return; }
        if (!keys.length) { SF.setStatus('Please upload at least one photo.',                    'error'); return; }
        app.contamDetails[item.id] = { lot, inoculated, attachmentKeys: keys };
        app.contamIdx += 1;
        if (app.contamIdx >= app.contamItems.length) SF.pushStep('contam-submit');
        else SF.renderStep();
        return;
      }
    }

    if (app.step === 'contam-submit') {
      if (t.closest('[data-action="submit-contam"]')) {
        await SF.submitContam();
        return;
      }
    }

    if (app.step === 'product-select') {
      if (t.closest('[data-action="product-items-next"]')) {
        if (!app.productProblemItems.length) { SF.setStatus('Please select at least one item.', 'error'); return; }
        app.productProblemIdx = 0;
        SF.pushStep('product-detail');
        return;
      }
    }

    if (app.step === 'product-detail') {
      if (t.closest('[data-action="product-detail-next"]')) {
        const item = app.productProblemItems[app.productProblemIdx];
        if (!item) { await SF.submitProductProblem(); return; }
        const desc = ((SF.main.querySelector('.sf-product-issue-desc') || {}).value || '').trim();
        if (!desc) { SF.setStatus('Please describe the issue with this item.', 'error'); return; }
        const uploader = app.uploaders['product_' + item.id];
        if (uploader && uploader.isUploading()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys = (uploader && uploader.getKeys()) || [];
        app.productProblemDetails[item.id] = { description: desc, attachmentKeys: keys };
        app.productProblemIdx += 1;
        if (app.productProblemIdx >= app.productProblemItems.length) {
          await SF.submitProductProblem();
        } else {
          SF.renderStep();
        }
        return;
      }
    }

  });

  try { SF.renderTop(); } catch (err) { SF.renderFatal(err); }

})();